import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { disabledText, disabledLight } from 'themes/colors';

const styles = theme => ({
  root: {
    display: 'block',
    padding: '10px 20px',
    marginRight: '0',
    fontSize: '0.875rem',
    fontWeight: '600',
    transition: 'background-color 0.3s',
    letterSpacing: '-0.013rem',
    lineHeight: '20px',
    color: `${disabledText} !important`,
    cursor: 'pointer',
    borderColor: 'transparent',
    borderBottom: '1px solid transparent',
    paddingBottom: '11px',
    '&:hover, &:focus, &.active': {
      outline: 'none',
      color: `${theme.palette.secondary['900']} !important`,
      borderBottomColor: theme.palette.secondary['100'],
      borderRadius: '0',
      borderColor: 'transparent',
      borderBottom: `2px solid ${theme.palette.secondary['300']}`,
    },
    '&.active': {
      borderRadius: '0',
      borderColor: 'transparent',
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    '&.disabled': {
      color: disabledLight,
    },
  },
});


const NavLinkWrapper = (props) => {
  const { classes } = props;
  return (
    <li>
      <NavLink
        {...props}
        className={classes.root}
      >
        {props.children}
      </NavLink>
    </li>
  );
};

NavLinkWrapper.propTypes = {
  classes: PropTypes.element.isRequired,
  children: PropTypes.element.isRequired,
};

export default withStyles(styles)(NavLinkWrapper);
